import { Component, ElementRef, ViewChild } from '@angular/core';
import { EditorService } from '../../md/service/editor.service';
import Swal from 'sweetalert2';
import { session } from '../../../environments/environment.session'
import { NgxSpinnerService } from 'ngx-spinner';
import { ClerkNocService } from '../service/clerk-noc.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ApprovalUserService } from '../../portal/service/approval-user.service';
import { ToastrService } from 'ngx-toastr';
import { MainService, MainService as mainserviceEmb } from '../../emb/service/main.service';
import { CommonDataService } from '../../emb/common _services/common-data.service';

import { NocHierService } from '../service/noc-hier.service';
import { LogService } from '../../portal/service/log.service';
import { AdminstrationService } from '../service/adminstration.service';
import { MainService as mainService_MD } from '../../md/service/main.service'
import { NEVER } from 'rxjs';
import { MainService as portalmainservice } from '../../portal/service/main.service';
import { json } from 'express';

import { Router } from '@angular/router';
import { AllEmpService } from '../../hrms/service/all-emp.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// import {MainService} from '../service/main.service';
import { Mainservice2Service } from '../service/mainservice2.service';

import * as moment from 'moment';

declare var $: any
@Component({
  selector: 'app-noc-list',
  templateUrl: './noc-list.component.html',
  styleUrls: ['./noc-list.component.css']
})
export class NocListComponent {
  ebillUser: any;
  b_acct_id: any;
  property_approved_flag: boolean = false
  item: any;
  tender_apprdata: any;
  constructor(public Mainservice2Service: Mainservice2Service, private allEmpService: AllEmpService, public portalmainservice: portalmainservice, public router: Router, private mainServiceMD: mainService_MD, private adminstration_S: AdminstrationService, private embHierService: NocHierService, private mainService: MainService, private log: LogService, public commonDataService: CommonDataService, public mainserviceEmb: mainserviceEmb, private toastr: ToastrService, public ApprovalUserService: ApprovalUserService, private editorService: EditorService, public spinner: NgxSpinnerService, public clerknocservice: ClerkNocService
  ) { }
  page_flag: boolean = true;
  bill_flag: boolean = false
  //  constructor(private mainService: MainService, public commonDataService: CommonDataService, public mainserviceEmb: mainserviceEmb, private toastr: ToastrService, public ApprovalUserService: ApprovalUserService, private editorService: EditorService, public spinner: NgxSpinnerService, public clerknocservice: ClerkNocService
  //   ,public router :Router) { }

  @ViewChild('uploaddocument', { static: false }) uploaddocument!: ElementRef;
  @ViewChild('uploadsupprotivedocument', { static: false }) uploadsupprotivedocument!: ElementRef;

  logObj = { component: 'CLERK REGISTRATION' }
  fourth: any;
  second: any;
  third: any;
  isLinear: any;
  first: any;
  show = false
  pet_details = null
  pet_data = []
  NocObj: any = {}

  displayedColumns: any = ['si_no', 'applicant_name', 'file_number', 'letter_number', 'status', 'action'];
  // displayedColumns1: any = ['si_no', 'document_type', 'file_number', 'file_desc', 'role', 'status', 'action'];

  displayedColumns1: any = ['si_no', 'file_number', 'file_desc', 'status', 'action'];


  datasource: any;
  datasource11: any;
  datasource1: any;
  datasource12: any;
  @ViewChild('paginator1', { static: false }) paginator1!: MatPaginator;
  @ViewChild('sortCol1', { static: false }) sortCol1!: MatSort;
  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    if (this.datasource) {
      this.datasource.paginator = value;
    }
  }
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    if (this.datasource) {
      this.datasource.sort = value;
    }
  }
  applyFilter1(filterValue: string) {
    this.datasource1.filter = filterValue.trim().toLowerCase();
  }

  applyFilter12(filterValue: string) {
    this.datasource12.filter = filterValue.trim().toLowerCase();
  }
  house_flag: boolean = false
  clerk_flag = false
  ctp_flag = false
  eng_Dept_flag = false
  role: any
  status: any
  flag_status: any;
  AMC_reject_flag : boolean = false;
  async ngOnInit() {
    console.log(this.mainServiceMD.codeValueTechObj);
    console.log(this.mainServiceMD.codeValueTechObj['NOC02'])
    this.status = null
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    await this.getAllUsersInfo()
    await this.getfileid()
    console.log(this.ebillUser, this.UserObj)

    // await this.get_party_data();
    // await this.get_issue_data();
    await this.getnode_cd();
    await this.getallworkflowuser();
    console.log(this.ebillUser);
    // await this.getAllTaskOflastlevelappproval('116')

    this.role = null

    // await this.commonDataService.getAllRolesWIthResource(this.b_acct_id)
    console.log(this.ebillUser.role_cd)

    for (let i = 0; i < this.ebillUser.role_cd.length; i++) {
      if (this.ebillUser.role_cd[i] == 'CRK') {
        this.role = this.ebillUser.role_cd[i]
        this.clerk_flag = true
        this.ctp_flag = false
        this.eng_Dept_flag = false
        this.status = "ASSIGN_" + this.role
        await this.getallfiledata()
      } else if (this.ebillUser.role_cd[i] == 'CTP') {
        this.role = this.ebillUser.role_cd[i]
        this.clerk_flag = false
        this.ctp_flag = true
        this.eng_Dept_flag = false
        this.status = "ASSIGN_" + this.role
      } else if (this.ebillUser.role_cd[i] == 'CARTOGRAPHER') {
        this.clerk_flag = false;
        this.ctp_flag = false;
        this.eng_Dept_flag = true;
        this.role = this.ebillUser.role_cd[i];
        console.log(this.role);

        // this.status = "ASSIGN_" + this.role;
        this.status = "ASSIGN_"
        this.flag_status = "ASSIGN_" + this.role
        console.log(this.status);

        await this.filedatasendbyctp();
      }
      // else if (this.ebillUser.role_cd[i] == 'JE_ENG_DEPT' || this.ebillUser.role_cd[i] == 'AE_ENG_DEPT' || this.ebillUser.role_cd[i] == 'EE_ENG_DEPT') {
      //   this.clerk_flag = false
      //   this.ctp_flag = false
      //   this.eng_Dept_flag = true
      //   this.role = this.ebillUser.role_cd[i]
      //   this.status="ASSIGN_"+ this.role
      //   await this.filedatasendbyctp()
      // }
      // Iterate through the ebillUser.role_cd array
      // for (let i = 0; i < this.ebillUser.role_cd.length; i++) {
      // Check if the current role is in the role_cdArr
      else if (this.role_cdArr.includes(this.ebillUser.role_cd[i])) {
        // Set the flags and other variables
        this.clerk_flag = false;
        this.ctp_flag = false;
        this.eng_Dept_flag = true;
        this.role = this.ebillUser.role_cd[i];
        console.log(this.role);

        // this.status = "ASSIGN_" + this.role;
        this.status = "ASSIGN_"
        this.flag_status = "ASSIGN_" + this.role
        console.log(this.status);

        await this.filedatasendbyctp();
        // break; // Exit the loop if a matching role is found
      }
      // }
    }
    console.log(this.ctp_flag, this.clerk_flag);
    await this.last_appr_property();
    await this.getAllTaskOfUser();
    if (this.ebillUser['role_cd'].includes('ZO')) {
      this.house_flag = true;
    }
    if (this.ebillUser['role_cd'].includes('AMC')) {
      this.AMC_reject_flag = true;
    }
    console.log(this.house_flag, this.eng_Dept_flag, 'house flag');

  }
  validateMobile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 0 && input.value.charAt(0) === '0') {
      input.value = input.value.slice(1);
    }
    input.value = input.value.replace(/[^0-9]/g, '');
    this.NocObj.party_mobile = input.value;

  }

  async getLastLevelRoles(data: any) {
    return data.reduce((acc: any, item: any) => {
      const existing = acc.find((d: any) => d.doc_type === item.doc_type);
      if (!existing || existing.level < item.level) {
        acc = acc.filter((d: any) => d.doc_type !== item.doc_type);
        acc.push(item);
      }
      return acc;
    }, []);
  };

  role_cdArr: any = []
  AllWorkFlow_Data: any = []
  lastlevel_data: any = []
  async getallworkflowuser() {
    this.spinner.show();
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING', 'CARTOGRAPHER']
    obj["module_cd"] = 'NOC'
    obj["role"] = this.role
    obj["status"] = 'ACTIVE'
    let resp = await this.clerknocservice.getallworkflowuser(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.role_cdArr = []
      this.AllWorkFlow_Data = []
      this.AllWorkFlow_Data = resp.data
      this.role_cdArr = resp.data.map((item: { role_cd: any; }) => item.role_cd)
      console.log(this.role_cdArr, 'allrolecode');
      this.lastlevel_data = []
      this.lastlevel_data = await this.getLastLevelRoles(resp.data);
      console.log(this.lastlevel_data);
      this.spinner.hide();
    } else {
      Swal.fire('error', 'server side error', 'error');
      this.spinner.hide();
      return
    }
  }
  list_flag: any = true
  create_flag: any = false
  update_flag: any = false
  async open_create() {
    await this.editorService.clearTetx()

    this.NocObj = {}
    await this.getfileid()
    this.list_flag = false
    this.create_flag = true
    this.update_flag = false
    this.avivalid = false;
    this.spanAvi = false;
  }

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
  applyFilter11(filterValue: string) {
    this.datasource11.filter = filterValue.trim().toLowerCase();
  }
  node_code: any = []
  async getnode_cd() {
    this.spinner.show();
    let obj: any = {}
    this.node_code = []
    obj["b_acct_id"] = this.b_acct_id;
    obj["user_id"] = this.ebillUser.user_id
    obj["status"] = 'ACTIVE'
    let resp = await this.clerknocservice.getnode_cd(JSON.stringify(obj))
    console.log(resp);
    if (resp["error"] == false) {
      this.node_code = resp['data'].map((item: { node_cd: any; }) => item.node_cd)
      this.spinner.hide();
    } else {
      Swal.fire('error', 'Server side error', 'error');
      this.spinner.hide();
      return
    }
  }

  async get_list() {
    this.show = true;
    this.pet_details = null;
    this.pet_data = [];
    // await this.get_party_data();
  }

  // async get_party_data() {

  // }
  addJoining() {

  }
  // get_issue_data() {

  // }
  maxFiled_id: any = {};
  async getfileid() {
    this.spinner.show();
    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id
    let resp = await this.clerknocservice.getmaxfileid(JSON.stringify(obj))
    if (resp["error"] == false) {
      this.maxFiled_id = resp.data;
      this.NocObj['file_number'] = this.maxFiled_id['file_number']
      this.NocObj['file_id'] = this.maxFiled_id['file_id']
      this.spinner.hide();
    } else {
      Swal.fire('error', 'Server Side Error', 'error');
      this.spinner.hide();
      return
    }

  }

  all_data_arr: any = []
  async getallfiledata() {
    this.spinner.show();
    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id
    let resp = await this.clerknocservice.getallclerkfiledata(JSON.stringify(obj))
    if (resp["error"] == false) {
      this.all_data_arr = []
      this.all_data_arr = resp.data;
      let j = 1
      for (let i = 0; i < this.all_data_arr.length; i++) {
        this.all_data_arr[i]['new_index'] = j
        j = j + 1
      }
      this.spinner.hide();
    }
    else {
      Swal.fire("Error", "Server Side Error", 'error');
      this.spinner.hide();
    }
    console.log(this.all_data_arr);
    let without_reject_data: any = []
    let rejcted_Data: any = []
    this.all_data_arr = this.all_data_arr.filter((item: any) => {
      if (!['INACTIVE', 'REJECTED', 'OBJECTION'].includes(item.life_cycle_status)) {
        without_reject_data.push(item)
        // if(['REJECTED', 'OBJECTION'].includes(item.life_cycle_status))
      } else {
        rejcted_Data.push(item)
      }
    })
    console.log(without_reject_data, rejcted_Data);

    this.spinner.hide();

    this.datasource = new MatTableDataSource(without_reject_data)
    this.datasource.paginator = this.paginator;
    this.datasource.sort = this.sort;

    this.datasource11 = new MatTableDataSource(rejcted_Data)
    this.datasource11.paginator = this.paginator;
    this.datasource11.sort = this.sort;

  }

  avivalid: boolean = false
  spanAvi: boolean = false;
  gAvi: boolean = false;
  checkEmail(obj: any) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/; // The regex now checks for any domain extension with 2+ characters
    if (obj.match(mailformat)) {
      let d = obj.split('.');

      if (d && d.length > 1) {
        // Ensuring the domain part has a valid extension length (2 or more characters)
        let domainExtension = d[(d.length) - 1];
        if (domainExtension.length >= 2) {
          this.avivalid = true;
          this.spanAvi = true;
        } else {
          this.avivalid = false;
          this.spanAvi = false;
        }
      }
    } else {
      this.avivalid = false;
      this.spanAvi = false;
    }
  }


  async filedatasendbyctp() {
    this.spinner.show();
    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id
    obj["role"] = this.role
    // obj["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING']
    // obj["status"]='LAST_LEVEL_APPROVED'
    let resp = await this.clerknocservice.getallclerkfiledata(JSON.stringify(obj))
    console.log(resp);
    if (resp["error"] == false) {
      this.all_data_arr = []
      this.all_data_arr = resp.data;

      //console.log(this.NocObj);
      let j = 1
      for (let i = 0; i < this.all_data_arr.length; i++) {
        this.all_data_arr[i]['new_index'] = j
        j = j + 1
      }
      console.log(this.all_data_arr);
      this.spinner.hide();
      console.log(this.eng_Dept_flag, this.house_flag)
    }
    else {
      Swal.fire("Error", "Server Side Error", 'error');
      this.spinner.hide();
      return
    }
    this.spinner.hide();
    this.datasource = new MatTableDataSource(this.all_data_arr)
    this.datasource.paginator = this.paginator;
    this.datasource.sort = this.sort;

  }

  add_user_flag = false
  async open_list() {
    this.list_flag = true
    this.create_flag = false
    this.update_flag = false
    this.add_user_flag = false
    this.show_ctp_flag = false

  }

  selectedFile2: any = []
  selected_file_name2: any = []
  upload_name_arr: any = []
  private readonly MAX_TOTAL_SIZE = 5 * 1024 * 1024; // 5 MB
  private readonly ALLOWED_TYPES = ['application/pdf', 'image/png', 'image/jpeg'];

  async uploaddoc(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      let totalSize = 0;
      const invalidFiles = files.filter(file => {
        totalSize += file.size;
        return !this.ALLOWED_TYPES.includes(file.type) || totalSize > this.MAX_TOTAL_SIZE;
      });
      let errorMessage;

      if (totalSize > this.MAX_TOTAL_SIZE) {
        errorMessage = ` Total file size exceeds the limit of 5 MB.\n`;
        Swal.fire('Info', errorMessage, 'info');
      }

      if (invalidFiles.length > 0) {
        let errorMessage = 'This is support only this type  PDF, PNG, or JPEG of file support .` ';
        invalidFiles.forEach(file => {
          if (!this.ALLOWED_TYPES.includes(file.type)) {
            errorMessage += `PDF, PNG, or JPEG of file support .`;
          }
          // if (totalSize > this.MAX_TOTAL_SIZE) {
          //   errorMessage += `- Total file size exceeds the limit of 5 MB.\n`;
          // }
        });
        Swal.fire('Info', errorMessage, 'info');
        // Optionally, you can clear the input if there are invalid files
        input.value = '';
        this.selectedFile = null
        return;
      }

      // Proceed with valid files
      // Your upload logic here
      console.log('Valid files:', files);
    }
    this.selected_file_name2 = []
    this.selectedFile2 = []
    this.upload_name_arr = []
    if (event.target.files.length == 0) {
      for (let i = 0; this.upload_name_arr.length; i++) {
        if (this.upload_name_arr[i] == this.selected_file_name2) {
          this.upload_name_arr.splice(i, 1)
          break
        }
      }
      this.selectedFile2 = {}
      this.selected_file_name2 = ""
      return
    }

    // let resp = await this.validatePdfSize(event)
    // if (!resp) {
    //   // this.reset();
    //   this.uploaddocument.nativeElement.value = null;
    //   return
    // }

    for (let i = 0; i < event.target.files.length; i++) {


      this.selectedFile2[i] = event.target.files[i];
      this.selected_file_name2[i] = event.target.files[i]['name']
    }

    //console.log(this.selectedFile2);


    if (this.upload_name_arr.includes(this.selected_file_name2) == true) {
      Swal.fire('Warning...', 'Same Name Document can not be Uploaded', 'warning')
      this.uploaddocument.nativeElement.value = null;
      return;
    } else {
      this.upload_name_arr = this.selected_file_name2
    }
    //console.log(this.upload_name_arr)
    let file_name = [];
    //console.log(this.selectedFile2);

    if (this.selectedFile2.length > 0) {
      for (let i = 0; i < this.selectedFile2.length; i++) {

        file_name[i] = this.selected_file_name2[i].split('.')
      }
    }

    // if (file_name.length < 2 || file_name[file_name.length - 1] != 'pdf') {
    //   this.selectedFile2 = null;
    //   // this.reset();
    //   this.uploaddocument.nativeElement.value = null;

    //   Swal.fire('Warning...', 'File Numbert Supported , Please upload pdf format file', 'warning')
    //   return;
    // }

    this.NocObj['upload_doc'] = this.selected_file_name2
    //console.log(this.NocObj)
  }


  selectedFile: any = []
  selected_file_name: any = []

  async addsupprotivedoc(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      let totalSize = 0;
      const invalidFiles = files.filter(file => {
        totalSize += file.size;
        return !this.ALLOWED_TYPES.includes(file.type) || totalSize > this.MAX_TOTAL_SIZE;
      });
      let errorMessage;

      if (totalSize > this.MAX_TOTAL_SIZE) {
        errorMessage = ` Total file size exceeds the limit of 5 MB.\n`;
        Swal.fire('Info', errorMessage, 'info');
      }

      if (invalidFiles.length > 0) {
        let errorMessage = 'This is support only this type  PDF, PNG, or JPEG of file support .` ';
        invalidFiles.forEach(file => {
          if (!this.ALLOWED_TYPES.includes(file.type)) {
            errorMessage += `PDF, PNG, or JPEG of file support .`;
          }
          // if (totalSize > this.MAX_TOTAL_SIZE) {
          //   errorMessage += `- Total file size exceeds the limit of 5 MB.\n`;
          // }
        });
        Swal.fire('Info', errorMessage, 'info');
        // Optionally, you can clear the input if there are invalid files
        input.value = '';
        this.selectedFile = null
        return;
      }

      // Proceed with valid files
      // Your upload logic here
      console.log('Valid files:', files);
    }
    this.upload_name_arr = []
    this.selectedFile = []
    this.selected_file_name = []
    if (event.target.files.length == 0) {
      for (let i = 0; this.upload_name_arr.length; i++) {
        if (this.upload_name_arr[i] == this.selected_file_name) {
          this.upload_name_arr.splice(i, 1)
          break
        }
      }
      this.selectedFile = []
      this.selected_file_name = []
      return
    }
    // let resp = await this.validatePdfSize(event)
    // if (!resp) {
    //   // this.reset();
    //   this.uploadsupprotivedocument.nativeElement.value = null;
    //   return
    // }

    for (let i = 0; i < event.target.files.length; i++) {

      this.selectedFile[i] = event.target.files[i];
      this.selected_file_name[i] = event.target.files[i]['name']
    }


    if (this.upload_name_arr.includes(this.selected_file_name) == true) {
      Swal.fire('Warning...', 'Same Name Document can not be Uploaded', 'warning')
      this.uploaddocument.nativeElement.value = null;
      return;
    } else {
      this.upload_name_arr = this.selected_file_name
    }
    let file_name = [];
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        file_name[i] = this.selected_file_name[i].split('.')
      }
    }
    // if (file_name.length < 2 || file_name[file_name.length - 1] != 'pdf') {
    //   this.selectedFile2 = null;
    //   // this.reset();
    //   this.uploaddocument.nativeElement.value = null;

    //   Swal.fire('Warning...', 'File Numbert Supported , Please upload pdf format file', 'warning')
    //   return;
    // }
    this.NocObj['supportive_doc'] = this.selected_file_name
    console.log(this.NocObj['supportive_doc'], "supportive document")
  }



  async validatePdfSize(input: any) {

    const fileSize = Array.from(input.target.files).map((item: any) => {
      return item.size / 1024; // size in KB
    });

    // Convert KB to MB
    const fileSizeInMB = fileSize.map(sizeInKB => sizeInKB / 1024);

    //console.log(fileSizeInMB);

    // const fileSize = input.target.files[0].size / 1024; // in MiB
    let numb: any = fileSizeInMB;
    if (numb > 250) {
      // alert('to big, maximum is 2MiB. You file size is: ' + numb + ' KB');
      Swal.fire('Information', 'to big, maximum is 250KB. You file size is: ' + numb + ' KB', 'info')

      return false
    } else {
      return true
    }
  }

  remark_note: any = null
  async submit() {

    if (this.spanAvi == false) {
      Swal.fire('Info', "Please Enter Valid Email ID", 'info')
      return
    }
    if (!this.NocObj['all_floor_area']) {
      Swal.fire('info', 'Please Enter All Floors Building area', 'info');
      return
    }
    if (!this.NocObj['total_area']) {
      Swal.fire('info', 'Please Enter Total Area', 'info');
      return
    } if (!this.NocObj['front_setback']) {
      Swal.fire('info', 'Please Enter Front Setback', 'info');
      return
    } if (!this.NocObj['left_set']) {
      Swal.fire('info', 'Please Enter Side Setback Left', 'info');
      return
    } if (!this.NocObj['right_set']) {
      Swal.fire('info', 'Please Enter Side Setback Right', 'info');
      return
    } if (!this.NocObj['back_setback']) {
      Swal.fire('info', 'Please Enter Rare Set Back', 'info');
      return
    }



    if (this.NocObj['file_number'] == undefined || this.NocObj['file_number'] == null || this.NocObj['file_number'] == '' ||
      this.NocObj['lda_letter_number'] == undefined || this.NocObj['lda_letter_number'] == null || this.NocObj['lda_letter_number'] == '' ||
      this.NocObj['party_name'] == undefined || this.NocObj['party_name'] == null || this.NocObj['party_name'] == '' ||
      this.NocObj['party_mobile'] == undefined || this.NocObj['party_mobile'] == null || this.NocObj['party_mobile'] == '' ||

      this.NocObj['building_type'] == undefined || this.NocObj['building_type'] == null || this.NocObj['building_type'] == '' ||
      this.NocObj['subject'] == undefined || this.NocObj['subject'] == null || this.NocObj['subject'] == '' ||
      this.NocObj['party_email'] == undefined || this.NocObj['party_email'] == null || this.NocObj['party_email'] == '' ||
      this.NocObj['khasra_no'] == undefined || this.NocObj['khasra_no'] == null || this.NocObj['khasra_no'] == '' ||
      this.NocObj['plot_no'] == undefined || this.NocObj['plot_no'] == null || this.NocObj['plot_no'] == '' ||
      this.NocObj['address'] == undefined || this.NocObj['address'] == null || this.NocObj['address'] == ''
    ) {
      Swal.fire('info', 'All fields marked with * are Mandatory.', 'info')
      return;
    }

    else {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Add it!'
      }).then((result: any) => {
        if (result.value) {
          this.submitnocdata()
        }
      })
    }


    // let data = new FormData()
    // let doc_type = { 'supp_doc': [], 'doc_arr': [] }
    // let doc_name = { 'supp_doc': [], 'doc_arr': [] }
    // if (this.selectedFile.length > 0) {
    //   for (let i = 0; i < this.selectedFile.length; i++) {

    //     data.append('file', this.selectedFile[i])
    //   }
    //   doc_type['supp_doc'].push('supportivedoc' as never)
    //   doc_name['supp_doc'].push(this.selected_file_name as never)
    // }
    // if (this.selectedFile2.length > 0) {
    //   for (let i = 0; i < this.selectedFile2.length; i++) {

    //     data.append('file', this.selectedFile2[i])
    //   }
    //   doc_type['doc_arr'].push('uploaddoc' as never)
    //   doc_name['doc_arr'].push(this.selected_file_name2 as never)
    // }



    // this.NocObj["b_acct_id"] = this.b_acct_id
    // this.NocObj['doc_name'] = doc_name;
    // this.NocObj['doc_type'] = doc_type;
    // this.NocObj['user_id'] = this.ebillUser.user_id
    // // Use Object.assign() to merge the objects
    // // Iterate over the array and add each property to the existing object

    // this.remark_note = this.editorService.to_data


    // this.NocObj['description'] = this.remark_note
    // this.NocObj["lang"] = this.editorService.language
    // this.NocObj['department'] = null
    // // this.NocObj['create_role'] = 'CLERK'
    // this.NocObj['create_role'] = this.role

    // data.append('data', JSON.stringify(this.NocObj))
    // let resp = await this.clerknocservice.insertnocfiledata(data)
    // this.spinner.show()
    // if (resp["error"] == false) {
    //   this.spinner.hide()
    //   this.NocObj = {}
    //   Swal.fire('Success', "Successfully Submitted", 'success')
    //   await this.editorService.clearTetx()

    //   await this.open_list()
    //   await this.getallfiledata()

    // }
    // else if(resp["error"]=="check"){
    //   this.spinner.hide()
    //   Swal.fire('Error',"Please Enter Another LDA letter Number ",'info')
    // }
    // else {
    //   this.spinner.hide()
    //   this.NocObj = {}
    //   Swal.fire("Error", "Some Error Occured At Server Side", 'error')
    // }

  }

  async submitnocdata() {
    let data = new FormData()
    let doc_type = { 'supp_doc': [], 'doc_arr': [] }
    let doc_name = { 'supp_doc': [], 'doc_arr': [] }
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        data.append('file', this.selectedFile[i])
      }
      doc_type['supp_doc'].push('supportivedoc' as never)
      doc_name['supp_doc'].push(this.selected_file_name as never)
    }
    if (this.selectedFile2.length > 0) {
      for (let i = 0; i < this.selectedFile2.length; i++) {

        data.append('file', this.selectedFile2[i])
      }
      doc_type['doc_arr'].push('uploaddoc' as never)
      doc_name['doc_arr'].push(this.selected_file_name2 as never)
    }



    this.NocObj["b_acct_id"] = this.b_acct_id
    this.NocObj['doc_name'] = doc_name;
    this.NocObj['doc_type'] = doc_type;
    this.NocObj['user_id'] = this.ebillUser.user_id
    // Use Object.assign() to merge the objects
    // Iterate over the array and add each property to the existing object

    this.remark_note = this.editorService.to_data
    if (!this.remark_note) {
      Swal.fire('Info', 'Add notehseet to create file', 'info');
      return
    }

    this.NocObj['description'] = this.remark_note
    this.NocObj["lang"] = this.editorService.language
    this.NocObj['department'] = null
    // this.NocObj['create_role'] = 'CLERK'
    this.NocObj['create_role'] = this.role

    data.append('data', JSON.stringify(this.NocObj))
    let resp = await this.clerknocservice.insertnocfiledata(data)
    this.spinner.show()
    if (resp["error"] == false) {
      this.spinner.hide()
      this.NocObj = {}
      Swal.fire('Success', "Successfully Submitted", 'success')
      await this.editorService.clearTetx()

      await this.open_list()
      await this.getallfiledata()

    }
    else if (resp["error"] == "check") {
      this.spinner.hide()
      Swal.fire('Error', "Please Enter Another LDA letter Number ", 'info')
    }
    else {
      this.spinner.hide();
      Swal.fire("Error", "Some Error Occured At Server Side", 'error');
      return
    }

  }

  open_update(_element: any) {

  }

  delete(_element: any) {

  }
  workflowid: any = []

  async getallworklowidbyuser(item: any) {

    let obj: any = {}
    obj["b_acct_id"] = this.ebillUser.b_acct_id
    obj["role"] = item.role
    obj["doc_type"] = item.doc_type
    obj["doc_local_no"] = item.file_id
    obj["module_cd"] = 'NOC'
    let resp = await this.clerknocservice.getworkflowid(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.workflowid = []
      this.workflowid = resp['data'][0]['id']
    }
  }
  async getAllTaskOflastlevelappproval(file_id: any) {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj['doc_type'] = this.lastlevel_data.map((item: any) => item.doc_type)
    obj['role_cd'] = this.lastlevel_data.map((item: any) => item.role_cd)
    obj['status'] = 'PENDING'
    obj['module_cd'] = 'NOC'
    obj['doc_local_no'] = file_id
    let resp = await this.clerknocservice.getlastlevependingdata(JSON.stringify(obj))
    console.log(resp)
    return resp.data.length
  }

  undertakings: any = []
  async lastlevelappr() {

    await this.getallworklowidbyuser(this.alltabledata)
    let result = await this.getAllTaskOflastlevelappproval(this.alltabledata['file_id'])
    console.log(result)
    this.spinner.show()
    var obb: any = new Object();
    let status;
    if (this.eng_Dept_flag == true && result == 1) {
      // obb['doc_type'] = 'ENGINEERING'
      obb['doc_type'] = this.show_Data_obj['doc_type']
      obb['last_level_user'] = 'last_level_user'
      status = 'LAST_LEVEL_APPROVED'
      this.salBill_apprdata = this.alltabledata

    }
    else if (this.eng_Dept_flag == true) {
      obb['doc_type'] = this.show_Data_obj['doc_type']
      status = 'LAST_LEVEL_APPROVED'

      this.salBill_apprdata = this.alltabledata
    }

    obb['b_acct_id'] = this.ebillUser.b_acct_id
    // obb['remark'] = this.remark_note //this.appr_remark
    obb['remark'] = this.appr_remark

    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.workflowid
    obb['doc_local_no'] = this.salBill_apprdata['file_id']
    obb['undertaking'] = JSON.stringify([])

    // if (this.editorService.language == 'Hindi') {
    //   obb['language'] = 'Hindi'
    // } else {
    //   obb['language'] = 'English'
    // }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      if (this.eng_Dept_flag == true) {
        await this.changedeptstatus(this.salBill_apprdata['file_id'], status, obb)

        // await this.changelastdeptstatus(this.salBill_apprdata['file_id'], status, obb)

      }
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }

  }

  async changelastdeptstatus(id: any, status: any, obb: any) {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["file_id"] = id
    obj["life_cycle_status"] = status
    obj["user_id"] = this.ebillUser.user_id
    // if (obb['last_level_user']) {

    //   obj['last_level_user'] = obb['last_level_user']
    // } else {
    //   obj['last_level_user'] = null

    // }
    let resp = await this.clerknocservice.changelastleveldeptstatus(obj)
    if (resp["error"] == false) {
      this.spinner.hide()
      Swal.fire("Success", "Successfully Send to CTP", 'success')
    }
    else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }


  salBill_apprdata: any
  async send_to_ctp(element: any) {
    this.appr_remark = null
    this.forwarded_user_id = null
    console.log(element)
    let d_typ;
    if (element.under_village == 'YES') {
      d_typ = 'CARTOGRAPHER'
      this.send_to_carto = true;
    } else {
      d_typ = 'CTP'
    }



    this.salBill_apprdata = Object.assign({}, element)
    this.salBill_apprdata['level'] = 1
    this.salBill_apprdata['branch'] = 1
    this.salBill_apprdata['doc_local_no'] = this.salBill_apprdata['file_id']
    if (this.ctp_flag == true || this.clerk_flag == true) {

      this.salBill_apprdata['doc_type'] = d_typ//this.salBill_apprdata['id']
    } else if (this.eng_Dept_flag == true) {
      // this.salBill_apprdata['doc_type'] = 'ENGINEERING'//this.salBill_apprdata['id']
      this.salBill_apprdata['doc_type'] = this.show_Data_obj['doc_type']//this.salBill_apprdata['id']

    }
    this.salBill_apprdata['node_cd'] = element['node_cd'] ? element['node_cd'] : this.node_code;
    this.salBill_apprdata['module_cd'] = 'NOC';
    // this.salBill_apprdata['node_cd'] = this.node_code

    await this.ApprovalUserService.getWorkflowlog(this.ebillUser, this.salBill_apprdata['doc_type'], 'NOC');
    if (this.ApprovalUserService.workflow_level1 == undefined) {
      // await this.ChangestatusSalBill(this.salBill_apprdata['doc_local_no'], 'APPROVED')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.ebillUser, this.salBill_apprdata)
    await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, this.salBill_apprdata)
    console.log(this.ApprovalUserService.workuser);

    /* await this.getAllRule();
    await this.getundertakings(element); */
    $('#myModal3').modal('show');
  }
  message_flag: any = false
  // async getle(user_id: any) {
  //   let obj = Object()
  //   obj['b_acct_id'] = this.b_acct_id
  //   obj['le_id'] = user_id
  //   let resp = await this.mainserviceEmb.getcurrentlegalentity(JSON.stringify(obj))
  //   console.log(resp['data'])
  //   if (resp['error'] == false) {
  //     //await this.updatepending(this.tender_apprdata)
  //     await this.sendmessage(resp['data'][0]['phone_no'], resp['data'][0]['party_name']
  //     )
  //     this.spinner.hide();
  //     this.message_flag = false
  //     //this.toastr.successToastr("Approval Forwarded Successfully!!")
  //   } else {
  //     this.spinner.hide();
  //     Swal.fire("Error", resp['data'], 'error');
  //   }
  // }



  forwarded_user_id: any;
  appr_remark: any
  isResponseReceived: boolean = false;
  send_to_carto: boolean = false;
  async Approvedapproval() {
    this.spinner.show()
    let d_type;
    let d_status
    if (this.send_to_carto) {
      d_type = 'CARTOGRAPHER';
      d_status = 'ASSINGED_CARTOGRAPHER'
    } else {
      d_type = 'CTP'
      d_status = 'ASSINGED_CTP'
    }
    let obj: any = {}
    if (this.clerk_flag == true) {
      obj['doc_type'] = d_type
    } else if (this.eng_Dept_flag == true) {
      obj['doc_type'] = this.show_Data_obj['doc_type']

    }
    obj['doc_local_no'] = this.alltabledata['file_id']
    obj['module_cd'] = 'NOC'
    obj["b_acct_id"] = this.b_acct_id
    // obj["role_cd"] = this.role
    let status = this.status;
    let resp1 = await this.clerknocservice.getworkflowloguser(JSON.stringify(obj))
    if (resp1["error"] == false) {
      if (resp1.data.length == 0) {

        this.isResponseReceived = true
        this.spinner.show()
        this.isResponseReceived = true
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          let obb: any = new Object();

          obb['user_id'] = this.ebillUser.user_id
          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.appr_remark
          obb['remark'] = this.appr_remark
          obb['status'] = 'APPROVED'
          let status;
          if (this.clerk_flag == true) {

            obb['doc_type'] = d_type

            status = d_status
          } else if (this.eng_Dept_flag == true) {
            // obb['doc_type'] = 'ENGINEERING'
            obb['doc_type'] = this.show_Data_obj['doc_type']

            status = this.status + this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
            this.salBill_apprdata = this.alltabledata

          }
          obb['doc_local_no'] = this.salBill_apprdata['file_id']
          obb['doc_desc'] = `${this.salBill_apprdata['party_name']} 's  File Number ${this.salBill_apprdata['file_id']} Is Assigned to ${d_type}`
          // obb['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
          obb['role_cd'] = this.role//this.level1['role_cd']

          obb['module_cd'] = 'NOC'
          obb['node_cd'] = this.node_code
          obb['level'] = this.ApprovalUserService.level1['level']
          obb['undertaking'] = JSON.stringify([])
          obb['branch'] = this.ApprovalUserService.level1['branch']
          obb['user_name'] = this.ebillUser.party_name;
          obb['field_value'] = 0



          let resp = await this.mainserviceEmb.insertTask(obb)
          if (resp['error'] == false) {
            await this.pendingapproval()
            if (this.clerk_flag == true) {


              await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)
            } else if (this.eng_Dept_flag == true) {

              await this.changedeptstatus(this.salBill_apprdata['file_id'], status, obb)

            }
            else {

              await this.getallfiledata()
            }

            this.spinner.hide();
            if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {

              if (this.message_flag == true) {

              }

            } else {

            }
            if (this.send_to_carto) {
              await this.cartographer_insert_data();
            }
            this.toastr.success("Approval Forwarded Successfully!!")
            this.send_to_carto = false
            console.log("Approval Forwarded Successfully!!")
          } else {
            this.spinner.hide();
            console.log(resp['data'])
            this.isResponseReceived = false;
            // this.toastr.errorToastr(resp['data'])
          }
        } else {
          this.isResponseReceived = false;
          this.spinner.hide();
        }
      }
      else {
        this.allTaskArr = []
        let length = resp1.data.length
        this.allTaskArr = resp1.data[length - 1]
        this.spinner.show()
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          var obb: any = new Object();
          if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
            obb['user_id'] = -1
            if (this.allTaskArr['party_id'] == null || this.allTaskArr['party_id'] == undefined) {
              Swal.fire("Error", "Please Map Verdor with Work..!", 'error');
              return
            }
            obb['vendor_id'] = this.allTaskArr['party_id']
          } else {
            obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
          }
          if (obb["user_id"] == -1) {
            let userData: any = {};
            userData['b_acct_id'] = this.b_acct_id;
            userData['user_id'] = obb["vendor_id"];
            let venderInfo = await this.mainserviceEmb.getVenderName(JSON.stringify(obb));
            if (venderInfo["error"] == false) {
              obb['user_name'] = venderInfo["data"]['party_leagal_name']
            }
          } else {
            for (let i = 0; i < this.ApprovalUserService.workuser.length; i++) {
              if (this.ApprovalUserService.workuser[i]['user_id'] == obb["user_id"]) {
                let h = this.ApprovalUserService.workuser[i]['desc'].split("-");
                obb['user_name'] = h[1];
              }
            }
          }


          obb['doc_local_no'] = this.allTaskArr['doc_local_no']
          obb['doc_desc'] = this.allTaskArr['doc_desc']
          obb['node_cd'] = this.allTaskArr['node_cd']

          // if (this.selectedLang == 'Hindi') {
          //   obb['language'] = 'Hindi'
          // } else {
          //   obb['language'] = 'English'
          // }

          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.remark_note
          obb['remark'] = ""
          obb['status'] = 'PENDING'
          obb['doc_type'] = this.allTaskArr['doc_type']//'EBILL'
          // obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
          // obb['doc_desc'] = this.tender_apprdata['doc_desc']
          obb['undertaking'] = this.allTaskArr['undertaking']
          obb['module_cd'] = this.allTaskArr['module_cd'] //'EMB'
          // obb['node_cd'] = this.tender_apprdata['node_cd']
          if (this.ApprovalUserService.vendorflag == true) {
            obb['level'] = this.allTaskArr['level']
            obb['branch'] = this.allTaskArr['branch']
          }
          else {
            obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
            obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
            obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
          }

          obb['field_value'] = this.allTaskArr['field_value']
          var resp = await this.mainserviceEmb.insertTask(obb)

          if (resp['error'] == false) {
            // let a = ['TAX','ENGINEERING','PROPERTY'].includes(obb['doc_type'])
            // if(this.alltabledata['level'] != 1 && !a){

            // }
            await this.aftersentpendingapproval();
            if (this.clerk_flag == true) {
              await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)
            } else if (this.eng_Dept_flag == true) {

              await this.changedeptstatus(this.allTaskArr['doc_local_no'], status, obb)

            }

            this.spinner.hide();
            if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {

              if (this.message_flag == true) {

              }

            } else {

            }



            await this.getallfiledata();
            await this.filedatasendbyctp()
            this.toastr.success("Approval Forwarded Successfully!!")
            console.log("Approval Forwarded Successfully!!")
          } else {
            this.spinner.hide();
            console.log(resp['data'])
            this.isResponseReceived = false;
            // this.toastr.errorToastr(resp['data'])
          }
        } else {
          this.isResponseReceived = false;
          this.spinner.hide();
          //   }
        }
      }



    }
  }

  async underapprovalapproval(element: any) {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['status'] = 'UNDERAPPROVAL'
    obb['module_cd'] = this.salBill_apprdata['module_cd']
    obb['doc_type'] = this.salBill_apprdata['doc_type']
    obb['doc_local_no'] = this.salBill_apprdata['doc_local_no']
    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }

  }

  async aftersentpendingapproval() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['remark'] = this.remark_note //this.appr_remark
    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.allTaskArr['id']
    obb['doc_type'] = this.allTaskArr['doc_type']
    obb['undertaking'] = this.allTaskArr['undertaking'] ? this.allTaskArr['undertaking'] : JSON.stringify([])


    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }



  async approvedocmentwithcondition() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['module_cd'] = this.allTaskArr['module_cd']
    obb['status'] = 'APPROVED'
    obb['doc_type'] = this.allTaskArr['doc_type']
    obb['doc_local_no'] = this.allTaskArr['doc_local_no']

    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
      Swal.fire("Success", "Approved Successfully!!", 'success');
    } else {
      this.spinner.hide();

      Swal.fire("Error", resp['data'], 'error');

    }

  }





  // level1 = {};
  // async Approvedapproval() {
  //   this.spinner.show()
  //   this.isResponseReceived = true
  //   if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
  //     let obb: any = new Object();

  //     obb['user_id'] = this.ebillUser.user_id
  //     obb['b_acct_id'] = this.ebillUser.b_acct_id
  //     obb['forwarded_by'] = this.ebillUser.user_id
  //     obb['forward_msg'] = this.appr_remark
  //     obb['remark'] = this.appr_remark
  //     obb['status'] = 'APPROVED'
  //     let status;
  //     if (this.clerk_flag == true) {

  //       obb['doc_type'] = 'CTP'

  //       status = 'ASSINGED_CTP'
  //     } else if (this.eng_Dept_flag == true) {
  //       // obb['doc_type'] = 'ENGINEERING'
  //       obb['doc_type'] = this.show_Data_obj['doc_type']

  //       status = this.status
  //       this.salBill_apprdata = this.alltabledata

  //     }
  //     obb['doc_local_no'] = this.salBill_apprdata['file_id']
  //     obb['doc_desc'] = `File Number ${this.salBill_apprdata['file_id']} Is Assigned to CTP`
  //     // obb['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
  //     obb['role_cd'] = this.role//this.level1['role_cd']

  //     obb['module_cd'] = 'NOC'
  //     obb['node_cd'] = this.node_code
  //     obb['level'] = this.ApprovalUserService.level1['level']
  //     obb['undertaking'] = JSON.stringify([])
  //     obb['branch'] = this.ApprovalUserService.level1['branch']
  //     obb['user_name'] = this.ebillUser.party_name;
  //     obb['field_value'] = 0



  //     let resp = await this.mainserviceEmb.insertTask(obb)
  //     if (resp['error'] == false) {
  //       await this.pendingapproval()
  //       if (this.clerk_flag == true) {


  //         await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)
  //       } else if (this.eng_Dept_flag == true) {

  //         await this.changedeptstatus(this.salBill_apprdata['file_id'], status, obb)

  //       }
  //       await this.getallfiledata()

  //       this.spinner.hide();
  //       if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {

  //         if (this.message_flag == true) {

  //         }

  //       } else {

  //       }
  //       this.toastr.success("Approval Forwarded Successfully!!")
  //       console.log("Approval Forwarded Successfully!!")
  //     } else {
  //       this.spinner.hide();
  //       console.log(resp['data'])
  //       this.isResponseReceived = false;
  //       // this.toastr.errorToastr(resp['data'])
  //     }
  //   } else {
  //     this.isResponseReceived = false;
  //     this.spinner.hide();
  //   }
  // }
  async ChangeStatus(id: any, status: any, obb: any) {
    let data = new FormData()
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = status;
    obj['file_id'] = id
    obj["user_id"] = this.ebillUser.user_id
    obj["department"] = obb["doc_type"]
    obj["node_cd"] = obb["node_cd"]
    obj['role_cd'] = obj['role_cd']
    obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
    obj["forwared_by"] = this.role
    obj["description"] = this.show_Data_obj["description"]
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    data.append('data', JSON.stringify(obj))
    console.log(obj);

    this.spinner.show();
    let resp = await this.clerknocservice.changefilestatus(obj)
    // let resp = await this.clerknocservice.changedeptstatus(data)

    if (resp['error'] == false) {
      this.spinner.hide();
      console.log('Successfully Chaged to ' + status)
      await this.getallfiledata()
    }
    else {
      this.spinner.hide();
      this.toastr.error(resp['data']);
    }
  }


  async changedeptstatus(id: any, status: any, obb: any) {
    let data = new FormData()
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = status;
    obj['file_id'] = id
    obj["user_id"] = this.ebillUser.user_id
    obj["department"] = obb["doc_type"]
    obj["node_cd"] = obb["node_cd"]
    // obj['role_cd'] = obb['role_cd']
    if (this.ApprovalUserService.rolebyid.length > 0) {

      if (this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']) {

        obj['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
      }
      if (this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']) {

        obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
      }
    }
    obj["forwared_by"] = this.role
    obj["description"] = this.show_Data_obj["description"]
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj["life_cycle_status"] = this.status
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        data.append('file', this.selectedFile[i])
      }

    }
    if (obb['last_level_user']) {

      obj['last_level_user'] = obb['last_level_user']
    } else {
      obj['last_level_user'] = null

    }

    data.append('data', JSON.stringify(obj))
    console.log(obj);

    this.spinner.show();
    // let resp = await this.clerknocservice.changefilestatus(obj)
    let resp = await this.clerknocservice.changedeptstatus(data)

    if (resp['error'] == false) {
      this.spinner.hide();
      console.log('Successfully Chaged to ' + status)
      Swal.fire('Success', "Successfully Approved", 'success')
      this.list_flag = true;
      this.eng_Dept_flag = true
      this.show_ctp_flag = false
      await this.filedatasendbyctp();
    }
    else {
      this.spinner.hide();

      this.toastr.error(resp['data']);
    }
  }


  async pendingapproval() {
    let d_type;
    let d_status
    if (this.send_to_carto) {
      d_type = 'CARTOGRAPHER';
      d_status = 'ASSINGED_CARTOGRAPHER'
    } else {
      d_type = 'CTP'
      d_status = 'ASSINGED_CTP'
    }
    this.spinner.show()
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      let obb: any = new Object();
      if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
      } else {
        obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
        obb['user_name'] = this.ApprovalUserService.userObj[this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']]
      }

      console.log(this.forwarded_user_id)
      obb['b_acct_id'] = this.ebillUser.b_acct_id
      obb['forwarded_by'] = this.ebillUser.user_id
      obb['forward_msg'] = this.appr_remark
      obb['remark'] = this.appr_remark


      obb['status'] = 'PENDING'
      if (this.clerk_flag == true) {

        obb['doc_type'] = d_type
        // status = 'ASSINGED_CTP'
      } else if (this.eng_Dept_flag == true) {
        // obb['doc_type'] = 'ENGINEERING'
        obb['doc_type'] = this.show_Data_obj['doc_type']
        // status = 'ASSINGED_AE'
        this.salBill_apprdata = this.alltabledata
        // obb['status'] = 'APPROVED'
      }
      obb['doc_local_no'] = this.salBill_apprdata['file_id']
      obb['doc_desc'] = `${this.salBill_apprdata['party_name']} 's  File Number ${this.salBill_apprdata['file_id']} Is Assigned to ${d_type}`
      obb['module_cd'] = 'NOC'
      obb['node_cd'] = this.salBill_apprdata['node_cd']
      obb['undertaking'] = JSON.stringify([])
      if (this.ApprovalUserService.vendorflag == true) {
        obb['level'] = this.salBill_apprdata['level']
        obb['branch'] = this.salBill_apprdata['branch']
      }
      else {
        obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
        obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
        obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
      }
      obb['field_value'] = 0
      // var resp = await this.portalmainservice.updatetask(obb)
      let resp = await this.mainserviceEmb.insertTask(obb)
      if (resp['error'] == false) {

        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } else {
      this.spinner.hide();
    }
  }

  allTaskArr: any = []
  allAprvlData: any = []
  // show_ctp_flag_af_app_dep:any=false
  async getAllTaskOfUser() {
    this.spinner.show();
    this.allTaskArr = []
    var obj: any = Object()
    obj['b_acct_id'] = this.ebillUser.b_acct_id
    obj['user_id'] = this.ebillUser.user_id
    obj["status"] = ['PENDING', 'APPROVED', 'OBJECTION', 'REJECTED']
    obj["module_cd"] = 'NOC'

    obj["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING', 'CARTOGRAPHER']

    obj["role"] = this.role
    //     var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj))

    var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj));
    console.log(resp)

    if (resp['error'] == false) {
      this.allAprvlData = []
      this.allTaskArr = resp['data']


      // console.log(this.show_ctp_flag_af_app_dep,this.ctp_flag,this.list_flag);

      this.mainService.count = this.allTaskArr.length
      let j = 1
      for (let i = 0; i < this.allTaskArr.length; i++) {
        this.allTaskArr[i]['new_index'] = j
        j = j + 1
      }






      this.spinner.hide();


    } else {
      Swal.fire("Error", resp['data'], 'error');
      this.spinner.hide();
      return
    }

    let without_reject_data: any = []
    let rejcted_Data: any = []
    this.allTaskArr = this.allTaskArr.filter((item: any) => {
      // if(['REJECTED', 'OBJECTION'].includes(item.status))
      if (!['INACTIVE', 'REJECTED', 'OBJECTION'].includes(item.status)) {
        without_reject_data.push(item)
      } else {
        rejcted_Data.push(item)

      }
    })
    console.log(without_reject_data, rejcted_Data);
    if (this.data_from_last_approval_prop.length > 0) {
      for (let i = 0; i < this.data_from_last_approval_prop.length; i++) {
        for (let j = 0; j < without_reject_data.length; j++) {
          if (this.data_from_last_approval_prop[i]['file_id'] == without_reject_data[j]['doc_local_no']) {
            without_reject_data[j]['final_approved'] = true;
          }
        }
      }
    }
    console.log(without_reject_data)

    this.datasource12 = new MatTableDataSource(rejcted_Data)
    this.datasource12.paginator = this.paginator;
    this.datasource12.sort = this.sort;

    this.datasource1 = new MatTableDataSource(without_reject_data)
    this.datasource1.paginator = this.paginator1;
    this.datasource1.sort = this.sortCol1;

    // this.datasource1 = new MatTableDataSource(this.allTaskArr)
    // this.datasource1.paginator = this.paginator1;
    // this.datasource1.sort = this.sortCol1
  }
  hr_note_sheet = ""
  hr_notesheet_language: boolean = true
  show_Data_obj: any = {}
  decision_box: any = [{
    'code': "YES"
  }, {
    'code': 'NO'
  }]
  show_ctp_flag = false
  alltabledata: any = {}
  async add_to_approval(element: any) {
    this.property_approved_flag = false;
    console.log(element)
    console.log(element.status != 'APPROVED');
    console.log(element.final_approved);
    if (element.status == 'PENDING' && this.house_flag == true) {
      this.house_flag = true;
    } else {
      this.house_flag = false;
    }
    if (element['final_approved']) {
      this.property_approved_flag = true
    }
    if (element.house_tax_status === 'HOUSE_TAX_PAID') {
      this.house_flag = false;
    }

    await this.editorService.clearTetx()

    this.show_Data_obj = {}
    this.alltabledata = {}
    this.AllWorkFlow_Data
    let obj: any = Object.assign({}, element)
    this.alltabledata = Object.assign({}, element)
    console.log(this.alltabledata);
    console.log(this.AllWorkFlow_Data, "lllkkkkoo");
    console.log(this.role, "roleee");
    let arr = this.AllWorkFlow_Data.filter((item: any) => item.role_cd == this.role);
    console.log(arr);
    let alluperrole = []
    if (arr.length > 0) {
      const [{ level: targetLevel }] = arr;

      let secondarray = this.AllWorkFlow_Data.filter((item: any) =>
        arr.some((departmentObj: any) => departmentObj.doc_type === item.doc_type)
      );
      console.log(secondarray);

      let finalarr = secondarray.filter((item: any) => item.level <= targetLevel);
      console.log(finalarr);
      alluperrole = finalarr.map((item: any) => item.role_cd)

    } else {
      console.log("No matching role_cd found in AllWorkFlow_Data");
    }


    obj["b_acct_id"] = this.b_acct_id
    obj["role"] = ['CTP', 'CRK', ...alluperrole]
    console.log(obj);
    delete obj.forward_msg;
    obj["check"]
    let resp = await this.clerknocservice.getfiledatabyfileid(obj)
    console.log(resp)
    if (resp["error"] == false) {
      this.show_Data_obj["file_details"] = resp['file_detail'][0]
      this.show_Data_obj["file_notesheet"] = resp['file_notesheet']
      this.show_Data_obj["file_supp_doc"] = resp['file_supp_doc']
      this.show_Data_obj["party_doc"] = resp['party_doc']

      if (this.show_Data_obj["file_notesheet"].length > 0) {
        this.show_Data_obj["file_notesheet"].map((x: any) => {
          if (x && 'description' in x) {
            try {
              const parsedRemark = JSON.parse(x['description']);
              if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
                x['description'] = parsedRemark['body'];

              }
            } catch (e) {
              console.log('error')

            }
          }
        })
      }


      // console.log(this.show_Data_obj, " this.show_Data_obj")
      // console.log(this.all_data_arr, " this.all_data_arr")


      this.show_Data_obj['doc_type'] = null

      // Find the matching object in the array based on file_id
      const matchingObject = this.all_data_arr.find((item: { file_id: any; }) => item.file_id == this.show_Data_obj['file_details']['file_id']);
      console.log(matchingObject);

      // Add the doc_type to the file_details object if a match is found
      if (matchingObject) {
        this.show_Data_obj['doc_type'] = matchingObject['doc_type'];
      }



      console.log(this.show_Data_obj, " this.show_Data_obj")

      this.show_ctp_flag = true
      this.list_flag = false

    }
  }
  added_notesheet: any = false
  async addmorenotesheet() {




    await this.editorService.clearTetx()
    this.added_notesheet = true
    $('#notesheetmodal').modal('show');

    console.log(this.show_Data_obj["file_notesheet"]);

  }

  current_noc_data: any = []
  addctpnotesheet() {
    this.current_noc_data = []
    this.remark_note = this.editorService.to_data
    this.current_noc_data["description"] = JSON.parse(this.remark_note).body
    this.current_noc_data["lang"] = this.editorService.language
    console.log(this.current_noc_data);
    this.show_Data_obj["description"] = this.remark_note
    this.show_Data_obj["lang"] = this.editorService.language
    console.log(this.show_Data_obj);
    this.added_notesheet = false
    $('#notesheetmodal').modal('hide');
  }
  async uploadmoredoc() {
    $('#uploadmoredocmodal').modal('show');
    console.log(this.NocObj);

  }

  async submtctpdata() {
    this.spinner.show();
    console.log(this.show_Data_obj);
    console.log(this.NocObj)
    await this.getProjectHierFromAccount()
    await this.getAllEmployees()
    // Adding a new column called 'city' to each object
    this.project_hier = this.project_hier.map((obj: any) => {
      return { ...obj, 'user_name': '', 'user_name1': '', 'user_name2': '' };
    });
    // await this.getList()
    this.spinner.hide();
    $('#department').modal('show');

  }


  project_hier: any = []
  projhierobj: any = {};
  projhierobjtype: any = {};
  projhierobjtypecd: any = {};
  data: any = [{}]
  level1: any = []
  level2: any = []
  level3: any = []
  level4: any = []
  level5: any = []
  level6: any = []
  level7: any = []
  eng_Dept: any = []
  prop_Dept: any = []
  tax_Dept: any = []
  async getProjectHierFromAccount() {
    this.spinner.show();
    this.eng_Dept = []
    this.tax_Dept = []
    this.prop_Dept = []
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = "NOC";
    obj['zone_cd'] = [1104, 1105, 1106]
    let resp = await this.embHierService.getprojectHierarchy(obj);
    console.log(resp);
    for (let i = 0; i < resp.data.length; i++) {
      if (resp.data[i]["lvl1_cd"] == 1) {
        resp.data[i]["lvl1_value"] = "NOC-root";
      }
    }
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Project Hierarchy Received Successfully " })
      console.log(resp)
      console.log(this.data)
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]['lvl1_value'] == "All Projects") {
          resp.data[i]['lvl1_value'] = 'NOC-root'

        }
      }
      console.log(this.data)

      this.project_hier = resp['data']
      let arr: any = []
      let duumy: any = []
      for (let i = 0; i < this.project_hier.length; i++) {
        if (!arr.includes(this.project_hier[i]['lvl1_cd'])) {
          duumy.push({ lvl1_cd: this.project_hier[i]['lvl1_cd'], lvl1_value: this.project_hier[i]['lvl1_value'], lvl1_node_type: this.project_hier[i]['lvl1_node_type'] })
          arr.push(this.project_hier[i]['lvl1_cd'])
        }
      }
      this.level1 = duumy
      console.log(this.project_hier, this.level1, 'klklklklkllllllllllllllllklklklk')
      for (let i = 0; i < this.project_hier.length; i++) {

        if (this.project_hier[i]['leaf_cd'] == '1104') {
          this.eng_Dept.push(this.project_hier[i])

        }
        else if (this.project_hier[i]['leaf_cd'] == '1105') {
          this.prop_Dept.push(this.project_hier[i])

        }
        else if (this.project_hier[i]['leaf_cd'] == '1106') {
          this.tax_Dept.push(this.project_hier[i])
        }
      }

      this.eng_Dept = this.eng_Dept.map((obj: any) => {
        return { ...obj, 'user_name': '', 'role_cd': 'EE_ENG_DEPT', 'doc_type': 'ENGINEERING' };
      });
      this.prop_Dept = this.prop_Dept.map((obj: any) => {
        return { ...obj, 'user_name': '', 'role_cd': 'SDM', 'doc_type': 'PROPERTY' };
      });
      this.tax_Dept = this.tax_Dept.map((obj: any) => {
        return { ...obj, 'user_name': '', 'role_cd': 'ZO', 'doc_type': 'TAX' };
      });
      console.log(this.tax_Dept, this.prop_Dept, this.prop_Dept);
      this.spinner.hide();
      // this.dataSource = new MatTableDataSource(resp["data"]);
      // this.dataSource.paginator = this.paginator;
      // this.dataSource.sort = this.sort;
    } else {
      this.spinner.hide();
      Swal.fire("Error...", "Error While Getting Cost Center", "error");
    }
  }
  allEmplyees_new: any = []
  allEmployees: any = []
  allSearchableEmp: any = []
  userObj: any = {}
  async getAllEmployees() {
    console.log('all emp')
    this.spinner.show();
    var arr: any = []
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = 'NOC'
    var resp = await this.mainServiceMD.getuserformodulerolemapping(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "User for Module Role Mapping Received Successfully " })
      this.spinner.hide()
      arr = resp.data;
      console.log(resp, 'users')
      for (let i = 0; i < arr.length; i++) {
        this.userObj[arr[i]['user_id']] = arr[i]
        arr[i]['desc'] = arr[i]['user_id'] + " - " + arr[i]['emp_name'] + " - " + arr[i]['emp_phone_no']
      }
      this.allSearchableEmp = arr

    } else {
      this.spinner.hide()
    }
    console.log(this.allEmployees, this.allEmplyees_new, 'employees')
  }

  user_list = []
  user_list1 = []
  user_list2 = []

  async getList(node_cd: string | null | undefined) {
    console.log(node_cd);
    this.spinner.show();
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj["node_cd"] = node_cd
    console.log(obj, node_cd)
    if (node_cd == '1104') {
      obj["role_cd"] = 'EE_ENG_DEPT'

    } else if (node_cd == '1105') {
      obj["role_cd"] = 'SDM'

    } else {
      obj["role_cd"] = 'ZO'
    }
    console.log(obj)
    var resp = await this.adminstration_S.getUSTPAssigneddata2(JSON.stringify(obj));
    console.log(resp, resp, 'get list')
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "NOC Assigned Data Received Successfully" })
      this.spinner.hide();
      for (let i = 0; i < resp['data'].length; i++) {
        resp['data'][i]['name'] = this.userObj[resp['data'][i]['user_id']]['emp_name']
        resp['data'][i]['mobile'] = this.userObj[resp['data'][i]['user_id']]['emp_phone_no']
        for (let j = 0; j < this.project_hier.length; j++) {
          if (this.project_hier[j]['leaf_cd'] == resp['data'][i]['node_cd']) {
            let ob: any = {}
            ob = Object.assign({}, this.project_hier[j])
            let dummy = []
            for (let k = 0; k <= 7; k++) {
              if (ob['lvl' + k + '_cd']) {
                dummy.push(ob['lvl' + k + '_value'])
              }
            }
            resp['data'][i]['desc'] = dummy.join('-->')
          }

        }
      }
      // this.user_list = []
      // this.user_list1 = []
      // this.user_list2 = []
      if (node_cd == '1104') {
        this.user_list = []
        this.user_list = resp['data']
        console.log(resp['data']);
      } else if (node_cd == '1105') {
        // this.user_list=[]
        this.user_list1 = []
        this.user_list1 = resp['data']
        console.log(resp['data']);
      } else {
        // this.user_list=[]
        this.user_list2 = []
        this.user_list2 = resp['data']
        console.log(resp['data']);
      }



    }
    else {
      this.spinner.hide();
      Swal.fire('Error...', 'Some Error Occured', 'error');
    }

  }
  async submitctpdata() {
    this.spinner.show();
    // if (this.user_list2.length == 0 && this.user_list1.length == 0 && this.user_list.length == 0) {
    //   Swal.fire('Info', 'Please Select All filed', 'info')
    //   this.spinner.hide()

    //   return;
    // }
    // if (this.eng_Dept[0]['user_name'] == '' || this.eng_Dept[0]['user_name'] == null || this.eng_Dept[0]['user_name'] == undefined ||
    //   this.prop_Dept[0]['user_name'] == '' || this.prop_Dept[0]['user_name'] == null || this.prop_Dept[0]['user_name'] == undefined ||
    //   this.tax_Dept[0]['user_name'] == '' || this.tax_Dept[0]['user_name'] == null || this.tax_Dept[0]['user_name'] == undefined
    // ) {
    //   Swal.fire('Info', 'Please Select All filed', 'info')
    //   this.spinner.hide()

    //   return;
    // }
    console.log(this.project_hier);
    console.log(this.eng_Dept);

    console.log(this.prop_Dept);
    console.log(this.tax_Dept);

    console.log(this.NocObj)
    console.log(this.show_Data_obj);
    console.log(this.salBill_apprdata);


    let data = new FormData()
    let doc_type = { 'supp_doc': [], 'doc_arr': [] }
    let doc_name = { 'supp_doc': [], 'doc_arr': [] }
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        data.append('file', this.selectedFile[i])
      }
      doc_type['supp_doc'].push('supportivedoc' as never)
      doc_name['supp_doc'].push(this.selected_file_name as never)
    }


    this.remark_note = this.editorService.to_data
    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id
    if (this.property_approved_flag) {
      let b = this.user_list.filter((item: any) => item.user_id == this.eng_Dept[0]['user_name']);
      let c = this.user_list2.filter((item: any) => item.user_id == this.tax_Dept[0]['user_name']);
      this.eng_Dept[0]['dep_user_name'] = b[0]['name']
      this.tax_Dept[0]['dep_user_name'] = c[0]['name']
      obj["department"] = [...this.eng_Dept, ...this.tax_Dept];
    } else {
      let a = this.user_list1.filter((item: any) => item.user_id == this.prop_Dept[0]['user_name']);
      this.prop_Dept[0]['dep_user_name'] = a[0]['name']
      obj["department"] = [...this.prop_Dept];
    }
    obj["description"] = this.show_Data_obj["description"]
    // obj["supportive_doc"]=this.NocObj['supportive_doc']
    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language

    obj['create_role'] = 'CTP'
    obj["file_id"] = this.show_Data_obj['file_details']['file_id']
    obj["user_id"] = this.ebillUser.user_id
    obj["supportive_doc"] = this.NocObj['supportive_doc']


    obj['user_id'] = this.ebillUser.user_id
    // obj['b_acct_id'] = this.ebillUser.b_acct_id
    obj['forwarded_by'] = this.ebillUser.user_id
    obj['forward_msg'] = this.appr_remark
    obj['remark'] = this.appr_remark
    obj['status'] = 'APPROVED'
    obj['doc_type'] = 'CTP'
    obj['doc_local_no'] = this.show_Data_obj['file_details']['file_id']
    obj['doc_desc'] = `File Number ${this.show_Data_obj['file_details']['file_id']} Is Assigned to DEPARTMENT`
    obj['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
    obj['module_cd'] = 'NOC'
    // obj['node_cd'] = this.salBill_apprdata['node_cd']
    obj['node_cd'] = this.alltabledata['node_cd']
    obj['zo'] = false;
    obj['level'] = this.ApprovalUserService.level1['level']
    obj['undertaking'] = JSON.stringify([])
    obj['branch'] = this.ApprovalUserService.level1['branch']
    obj['user_name'] = this.ebillUser.party_name;
    obj['field_value'] = 0

    console.log(obj)

    data.append('data', JSON.stringify(obj))
    let resp = await this.clerknocservice.UPDATEnocfiledata(data)
    console.log(resp)
    if (resp["error"] == false) {
      this.spinner.hide()
      Swal.fire("SuccessFully", 'SuccessFully Send to Department', 'success')
      this.list_flag = true;
      this.ctp_flag = true
      this.show_ctp_flag = false

      await this.getAllTaskOfUser()
      $('#department').modal('hide');
      await this.editorService.clearTetx();
      await this.last_appr_property();
      await this.getAllTaskOfUser()
    
    } else {
      $('#department').modal('hide');

      this.spinner.hide()
      Swal.fire('Error', "Server Side Error", 'error')
    }
  }
  rejectDTObj: any = {}
  current_task_data: any = {}
  rejectdata: any = {}
  backrowdata: any = {}
  rejected_notesheet: any = false
  ft_satatus:any
  async reject(element: any, f_status: any) {
    this.ft_satatus = f_status
    console.log(element, f_status);
    this.rejected_notesheet = true
    await this.editorService.clearTetx()

    // this.clearSeletedData2();
    // let element = this.current_task_data
    this.current_task_data = {}
    this.current_task_data = element
    this.rejectdata = Object.assign({}, element)
    var obj: any = Object.assign({}, {})
    if (['SDM', 'ZO', 'EE_ENG_DEPT'].includes(element['role_cd']) && element.status == 'FORWARDED') {
      obj['forwarded_by'] = element['user_id']
      obj['user_id'] = 17700
      obj['user_name'] = 'Avinash Pathak' 
      obj['doc_type'] = 'CTP'
      obj['doc_local_no'] = element['doc_local_no']
      obj['doc_desc'] = element['doc_desc']
      obj['role_cd'] = 'CTP'
      obj['module_cd'] = element['module_cd']
      obj['node_cd'] = 1101
      obj['level'] = 2
      obj['branch'] = 1
      obj['field_value'] = 0
    }else{
     
      await this.ApprovalUserService.getWorkflowlogbydocno(this.ebillUser, element)
    this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
    if (this.current_task_data['module_cd'] === "ACCOUNT" && this.current_task_data['level'] === 1) {

    } else {
      if (!['OBJECTION', 'REJECTED'].includes(this.ApprovalUserService.workflowlogall[1]['status']) && this.ApprovalUserService.workflowlogall[1]['status'] != 'ACCOUNT_REJECTED') {
        if (this.ApprovalUserService.workflowlogall[1]['status'] == 'REVOKED' || this.ApprovalUserService.workflowlogall[1]['user_id'] == -1) {
          for (let i = 0; i < this.ApprovalUserService.workflowlogall.length; i++) {
            if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
            if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {

              obj = this.ApprovalUserService.workflowlogall[i]
              break;


            }


          }
        } else {
          obj = this.ApprovalUserService.workflowlogall[1]
        }

      } else {

        console.log(this.ApprovalUserService.workflowlogall);

        for (let i = 0; i < this.ApprovalUserService.workflowlogall.length; i++) {
          console.log(this.ApprovalUserService.workflowlogall[i]);

          if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
          if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {
            if (this.ApprovalUserService.workflowlogall[i]['user_id'] == element['user_id'] && this.ApprovalUserService.workflowlogall[i]['role_cd'] == element['role_cd']) {

              // if (this.ApprovalUserService.workflowlogall[i + 1] == undefined && this.rejectdata['doc_type'] == "DEFENDANT DOCS" && this.rejectdata['module_cd'] == 'ICMS') {
              //   // await this.finalreject()
              //   return;
              // }
              if (this.ApprovalUserService.workflowlogall[i + 1] == undefined) {
                break;

              }
              else {
                if (this.ApprovalUserService.workflowlogall[i + 1]['user_id'] == -1) {
                  obj = this.ApprovalUserService.workflowlogall[i + 2]
                  break;
                } else {
                  obj = this.ApprovalUserService.workflowlogall[i + 1]
                  break;
                }
              }


            }

          }


        }
      }
    }

    

    // ///////////////////////intenal doc type such as department to CTP ////////////////
    

      if (Object.keys(obj).length < 1) {
        for (let i = 0; i < this.ApprovalUserService.workflowlogall.length; i++) {
          if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
          if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {
            console.log(this.ApprovalUserService.workflowlogall[i]['user_id'], element['user_id'], this.ApprovalUserService.workflowlogall[i]['level'], element['level'], this.ApprovalUserService.workflowlogall[i]['branch'], element['branch'], this.ApprovalUserService.workflowlogall[i]['status'])
  
            if (this.ApprovalUserService.workflowlogall[i + 1]["status"] == "REJECTED" || this.ApprovalUserService.workflowlogall[i + 1]["level"] > element['level'] && this.ApprovalUserService.workflowlogall[i + 1]["branch"] >= element['branch'])
              continue;
            obj = this.ApprovalUserService.workflowlogall[i + 1]
            break;
  
  
          }
  
  
        }
      }
    }

    this.backrowdata = Object.assign({}, obj)
    this.backrowdata['f_status'] = f_status
    this.rejectDTObj = Object.assign({}, element)
    this.rejectDTObj['f_status'] = f_status
    $('#rejected').modal('show');

    // await this.finalreject()
  }
  async finalreject() {
    this.rejected_notesheet = false
    this.remark_note = this.editorService.to_data
    // let str = this.remark_note.trim()
    // if (str.length < 1) {
    if (this.remark_note == null) {
      Swal.fire('Info', "Please fill Mandatory Details", 'info');
      return
    }
    this.spinner.show()
    let obb = Object()
    obb['user_id'] = this.backrowdata['user_id']
    obb["user_name"] = this.backrowdata['user_name'];
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['forwarded_by'] = this.ebillUser.user_id
    obb['forward_msg'] = this.remark_note
    obb['remark'] = this.remark_note
    obb['status'] = 'PENDING'
    obb['doc_type'] = this.backrowdata['doc_type']//'EBILL'
    obb['doc_local_no'] = this.backrowdata['doc_local_no']
    obb['doc_desc'] = this.backrowdata['doc_desc']
    obb['role_cd'] = this.backrowdata['role_cd']
    obb['module_cd'] = this.backrowdata['module_cd'] //'EMB'
    obb['node_cd'] = this.backrowdata['node_cd']
    obb['level'] = this.backrowdata['level']
    obb['branch'] = this.backrowdata['branch']
    obb['field_value'] = this.backrowdata['field_value']
    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }

    const resp = await this.mainService.insertTask(obb)
    if (resp['error'] == false) {
      await this.rejectapproval(this.rejectDTObj['id'])
      if (['CTP','CARTOGRAPHER'].includes(obb['doc_type'])) {
        await this.rejectfilestatus(this.rejectDTObj['doc_local_no'], this.backrowdata['f_status'])
      }
      // if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.ebillUser.le_id])
      this.spinner.hide();
      // $('#multiple_view').hide()

      this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
      Swal.fire("Success",  `${this.ft_satatus} Successfully `, 'success');
      if (['CTP'].includes(this.role)) {
         await this.getAllTaskOfUser() 
        }
      await this.filedatasendbyctp();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }
  }
  async rejectfilestatus(data: any, status: any) {
    let obj: any = {}
    obj["file_id"] = data
    obj["status"] = status
    obj["b_acct_id"] = this.b_acct_id
    obj["user_id"] = this.ebillUser.user_id
    let resp = await this.clerknocservice.rejectfile(obj);
    console.log(resp);
    return resp;
  }
  async rejectapproval(element: any) {
    this.spinner.show()
    let obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['remark'] = this.remark_note
    obb['status'] = this.backrowdata['f_status']
    obb['id'] = element

    if (this.editorService.language == 'Hindi') {

      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }
    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }

  }
  async submitjedata() {
    console.log(this.alltabledata)
    console.log(this.show_Data_obj['doc_type']);

    // this.salBill_apprdata = Object.assign({}, alltabledata)
    this.alltabledata['level'] = 1
    this.alltabledata['branch'] = 1
    this.alltabledata['doc_local_no'] = this.alltabledata['file_id']
    // this.alltabledata['doc_type'] = 'ENGINEERING'//this.salBill_apprdata['id']
    this.alltabledata['doc_type'] = this.show_Data_obj['doc_type']//this.salBill_apprdata['id']

    this.alltabledata['node_cd'] = this.alltabledata['node_cd']
    this.alltabledata['module_cd'] = 'NOC';
    // this.alltabledata['node_cd'] = 1101
    console.log(this.alltabledata)

    // await this.ApprovalUserService.getWorkflowlog(this.ebillUser, 'ENGINEERING', 'NOC');
    await this.ApprovalUserService.getWorkflowlog(this.ebillUser, this.show_Data_obj['doc_type'], 'NOC');

    if (this.ApprovalUserService.workflow_level1 == undefined) {
      // await this.ChangestatusSalBill(this.salBill_apprdata['doc_local_no'], 'APPROVED')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.ebillUser, this.alltabledata)
    await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, this.alltabledata)
    /* await this.getAllRule();
    await this.getundertakings(element); */
    console.log(this.ApprovalUserService.workuser)
    console.log(this.ApprovalUserService.approvalflag, this.ApprovalUserService.vendorflag);

    $('#myModal3').modal('show');
  }


  // ////////////////////////////view file ///////////////////////
  view(element: any) {
    this.clerknocservice.file_id = element.doc_local_no !== undefined ? element.doc_local_no : element.file_id;
    this.router.navigate(['/noc-view']);
    this.clerknocservice.setData(this.router.url);
  }

  statusArr: any = []
  departmnt_data: any = {}
  async viewstatus(element: any) {
    console.log("i am here")
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["doc_local_no"] = element.doc_local_no !== undefined ? element.doc_local_no : element.file_id;
    obj['module_cd'] = 'NOC'
    obj['doc_type'] = ['CTP', 'BILL', 'ACCOUNTANT', 'CARTOGRAPHER']
    this.spinner.show();
    var resp = await this.mainserviceEmb.getWorkflowlog(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      let obj1: any = {}
      this.departmnt_data = {}
      obj1["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING']
      obj1["b_acct_id"] = this.b_acct_id
      obj1["file_id"] = element.doc_local_no !== undefined ? element.doc_local_no : element.file_id;
      let resp1 = await this.clerknocservice.getdepartmentdata(JSON.stringify(obj1))
      console.log(resp1);
      if (resp1["error"] == false) {
        this.departmnt_data['ENGINEERING'] = resp1['data'].filter((item: any) => item.doc_type == 'ENGINEERING')
        this.departmnt_data['PROPERTY'] = resp1['data'].filter((item: any) => item.doc_type == 'PROPERTY')
        this.departmnt_data['TAX'] = resp1['data'].filter((item: any) => item.doc_type == 'TAX')

      }


      // await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, element)
      // for (let i = 0; i < this.ApprovalUserService.workflowuser.length; i++) {
      //   this.UserObj[this.ApprovalUserService.workflowuser[i]['user_id']] = this.ApprovalUserService.workflowuser[i]['emp_name']

      // }
      console.log(resp1['data'])
      this.statusArr['CTP'] = resp['data'].filter((item: any) => item.doc_type == 'CTP' || item.doc_type == 'CARTOGRAPHER')
      this.statusArr['other'] = resp['data'].filter((item: any) => !['CTP','CARTOGRAPHER'].includes(item.doc_type)  )

      // this.statusArr = resp['data'];
      console.log(this.statusArr, "statusarr")
      console.log(this.departmnt_data, "departmnt_data")
      console.log(this.departmnt_data.length, "departmnt_data.length")
      console.log('myModal')
      $('#myModal').modal('show');
      this.spinner.hide()
    } else {
      this.spinner.hide();
      Swal.fire("Error", "Error while getting status");
    }
  }


  allUser: any = [];
  UserObj: any = {};
  async getAllUsersInfo() {
    this.spinner.show();
    var obj: any = {};
    obj["b_acct_id"] = this.b_acct_id
    var resp = await this.allEmpService.getAllPartyFields(JSON.stringify(obj));
    // var resp = await this.userAdd.getAllUsersInfo(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.allUser = resp['data'];
      for (let i = 0; i < this.allUser.length; i++) {
        this.UserObj[this.allUser[i]['le_id']] = this.allUser[i]['emp_name']
        this.allUser[i]['name'] = this.allUser[i]['emp_name']
      }
      console.log(this.UserObj);
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }
  alldata: any = []
  async viewdepstatus(element: any) {
    console.log("i am here")
    let arr = this.AllWorkFlow_Data.filter((item: any) => item.role_cd == this.role);
    let alluperrole = []
    // if (arr.length > 0) {
    //   const [{ level: targetLevel }] = arr;

    //   let secondarray = this.AllWorkFlow_Data.filter((item: any) =>
    //     arr.some((departmentObj: any) => departmentObj.doc_type === item.doc_type)
    //   );
    //   console.log(secondarray);

    //   let finalarr = secondarray.filter((item: any) => item.level <= targetLevel);
    //   console.log(finalarr);
    //   alluperrole = finalarr.map((item: any) => item.role_cd)

    // } else {
    //   console.log("No matching role_cd found in AllWorkFlow_Data");
    // }
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj['file_id'] = element.doc_local_no !== undefined ? element.doc_local_no : element.file_id;
    obj["doc_type"] = [...arr.map((item: any) => item.doc_type), 'CTP']
    console.log(obj["doc_type"])
    let resp = await this.clerknocservice.getdepartmentdata(JSON.stringify(obj))
    if (resp["error"] == false) {
      this.alldata = []
      this.alldata = resp['data']
    }
    console.log(this.alldata)
    $('#departmentworkflow').modal('show');

  }


  // forwarded_user_id:any
  // tender_apprdata:any = {}
  // appr_remark:any
  // async Approvedapproval() {
  //   this.remark_note = this.editorService.to_data
  //   // let str = this.remark_note.trim()
  //   // if (str.length < 1) {
  //   if (this.remark_note == null) {

  //     Swal.fire('Info', "Please fill Mandatory Details", 'info');
  //     return
  //   }
  //   this.spinner.show()
  //   if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
  //     var obb:any = new Object();
  //     // if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
  //     //   obb['user_id'] = -1
  //     //   if (this.selectedTender['party_id'] == null || this.selectedTender['party_id'] == undefined) {
  //     //     swal.fire("Error", "Please Map Verdor with Work..!", 'error');
  //     //     return
  //     //   }
  //     //   obb['vendor_id'] = this.selectedTender['party_id']
  //     // } 
  //     // else {
  //       obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
  //     // }
  //     if (obb["user_id"] == -1) {
  //       let userData:any = {};
  //       userData['b_acct_id'] = this.b_acct_id;
  //       userData['user_id'] = obb["vendor_id"];
  //       let venderInfo = await this.mainService.getVenderName(JSON.stringify(obb));
  //       if (venderInfo["error"] == false) {
  //         obb['user_name'] = venderInfo["data"]['party_leagal_name']
  //       }
  //     } else {
  //       for (let i = 0; i < this.ApprovalUserService.workuser.length; i++) {
  //         if (this.ApprovalUserService.workuser[i]['user_id'] == obb["user_id"]) {
  //           let h = this.ApprovalUserService.workuser[i]['desc'].split("-");
  //           obb['user_name'] = h[1];
  //         }
  //       }
  //     }


  //     if (this.tender_apprdata['doc_type'] == "BP") {
  //       let data:any = []
  //       let id_arr:any = []
  //       let doc_loca_arr:any = []
  //       let node_cd_arr:any = []
  //       this.allTaskArr.map((x:any) => {
  //         if (x['doc_type'] == "BP" && x['checked'] == true) {
  //           id_arr.push(x['id'])
  //           doc_loca_arr.push(x['doc_local_no'])
  //           node_cd_arr.push(x['node_cd'])
  //           data.push({
  //             id: x['doc_local_no'], // additional_property autoincrement id
  //             doc_desc: x['doc_desc'],
  //             node_cd: x['node_cd'],
  //           })
  //         }
  //       })
  //       obb['data'] = data;
  //       this.tender_apprdata['id'] = id_arr
  //       this.tender_apprdata['doc_local_no'] = doc_loca_arr
  //       this.tender_apprdata['node_cd'] = node_cd_arr
  //     } else {
  //       obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
  //       obb['doc_desc'] = this.tender_apprdata['doc_desc']
  //       obb['node_cd'] = this.tender_apprdata['node_cd']
  //     }
  //     // if (this.selectedLang == 'Hindi') {
  //     //   obb['language'] = 'Hindi'
  //     // } else {
  //     //   obb['language'] = 'English'
  //     // }

  //     obb['b_acct_id'] = this.ebillUser.b_acct_id
  //     obb['forwarded_by'] = this.ebillUser.user_id
  //     obb['forward_msg'] = this.remark_note
  //     obb['remark'] = ""
  //     obb['status'] = 'PENDING'
  //     obb['doc_type'] = this.tender_apprdata['doc_type']//'EBILL'
  //     // obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
  //     // obb['doc_desc'] = this.tender_apprdata['doc_desc']
  //     obb['undertaking'] = this.tender_apprdata['undertaking']
  //     obb['module_cd'] = this.tender_apprdata['module_cd'] //'EMB'
  //     // obb['node_cd'] = this.tender_apprdata['node_cd']
  //     if (this.ApprovalUserService.vendorflag == true) {
  //       obb['level'] = this.tender_apprdata['level']
  //       obb['branch'] = this.tender_apprdata['branch']
  //     }
  //     else {
  //       obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
  //       obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
  //       obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
  //     }

  //     obb['field_value'] = this.tender_apprdata['field_value']

  //     var resp = await this.mainService.insertTask(obb)
  //     if (resp['error'] == false) {
  //       await this.pendingapproval()
  //       // if (this.tender_apprdata['doc_type'] == 'EMB') await this.embdoc('UNDERAPPROVAL')
  //       // else 
  //       await this.underapprovalapproval(this.tender_apprdata)
  //       if (this.ApprovalUserService.conditionflag == true) await this.approvedocmentwithcondition()
  //       await this.getAllTaskOfUser()
  //       // if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
  //       //   if (this.message_flag == true) await this.getle(this.selectedTender['party_id'], this.ApprovalUserService.userObj[this.ebillUser.le_id])
  //       // } else {
  //       //   if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.ebillUser.le_id])

  //       // }
  //       this.spinner.hide();
  //       // if (this.ApprovalUserService.conditionflag == false) {
  //       //   // m_avinash
  //       //   // if (this.acrValid == true) {
  //       //   //   await this.updateStatusOfACR()
  //       //   //   await this.acrTrackInsert(obb)
  //       //   // }

  //       //   // $('#remark_view').modal('hide');
  //       //   // $('#multiple_view').hide()
  //       //   this.multiple_view = false
  //       //   this.remark_view = false
  //       //   this.button_flag = false
  //       //   this.task_list = true
  //       //   this.approval_flag = false
  //       //   this.reject_flag = false
  //       //   this.isApprovalButtonActive = false;
  //       //   // $('#myModal2').modal('hide');


  //       //   swal.fire("Success", "Approval Forwarded Successfully!!", 'success');

  //       // }

  //     } else {
  //       this.spinner.hide();
  //       Swal.fire("Error", resp['data'], 'error');

  //     }
  //   } else {
  //     Swal.fire("Error", "Please Select Any User..!", 'error');

  //     this.spinner.hide();
  //   }
  // }
  // // undertakings:any = []
  // async pendingapproval() {
  //   this.spinner.show()
  //   var obb:any = new Object();
  //   obb['b_acct_id'] = this.ebillUser.b_acct_id
  //   obb['remark'] = this.remark_note //this.appr_remark
  //   obb['status'] = 'APPROVED'
  //   obb['language'] = this.editorService.language
  //   obb['id'] = this.tender_apprdata['id']
  //   obb['doc_type'] = this.tender_apprdata['doc_type']
  //   obb['undertaking'] = this.tender_apprdata['undertaking'] ? this.tender_apprdata['undertaking'] : JSON.stringify([])


  //   if (this.editorService.language == 'Hindi') {
  //     obb['language'] = 'Hindi'
  //   } else {
  //     obb['language'] = 'English'
  //   }


  //   var resp = await this.mainService.updatetask(obb)
  //   if (resp['error'] == false) {
  //     this.spinner.hide();
  //   } else {
  //     this.spinner.hide();
  //     Swal.fire("Error", resp['data'], 'error');
  //   }
  // }



  // async underapprovalapproval(element:any) {
  //   this.spinner.show()
  //   var obb:any = new Object();
  //   obb['b_acct_id'] = this.ebillUser.b_acct_id
  //   obb['status'] = 'UNDERAPPROVAL'
  //   obb['module_cd'] = this.tender_apprdata['module_cd']
  //   obb['doc_type'] = this.tender_apprdata['doc_type']
  //   obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
  //   var resp = await this.mainService.updateWorkflowDocumentStatus(obb)
  //   if (resp['error'] == false) {
  //     this.spinner.hide();
  //   } else {
  //     this.spinner.hide();
  //     Swal.fire("Error", resp['data'], 'error');

  //   }

  // }
  // async approvedocmentwithcondition() {
  //   this.spinner.show()
  //   var obb:any = new Object();
  //   obb['b_acct_id'] = this.ebillUser.b_acct_id
  //   obb['module_cd'] = this.tender_apprdata['module_cd']
  //   obb['status'] = 'APPROVED'
  //   obb['doc_type'] = this.tender_apprdata['doc_type']
  //   obb['doc_local_no'] = this.tender_apprdata['doc_local_no']

  //   var resp = await this.mainService.updateWorkflowDocumentStatus(obb)
  //   if (resp['error'] == false) {
  //     this.spinner.hide();
  //     Swal.fire("Success", "Approved Successfully!!", 'success');
  //   } else {
  //     this.spinner.hide();

  //     Swal.fire("Error", resp['data'], 'error');

  //   }

  // }


  fileURL: any
  async view_correspondence(correspondence_no: any, file_id: any) {
    console.log(correspondence_no)
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_name'] = correspondence_no
    obj['file_id'] = file_id
    console.log(obj);

    var res = await this.clerknocservice.viewCorrespondence(obj)

    if (res) {
      let file = new Blob([res], { type: 'application/pdf' });
      this.fileURL = URL.createObjectURL(file);
      // console.log(fileURL)
      window.open(this.fileURL)
      // PDFObject.embed(this.fileURL, '#pdf')
    } else {

    }


  }



  export() {
    const dataToExport = this.datasource.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  export1() {
    const dataToExport = this.datasource1.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Doc Type': row.doc_type,
      'File Number': row.doc_local_no,
      'Doc Desc': row.doc_desc,
      'Role': row.role_cd,

      'Status': row.status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file_workflow');
  }
  export11() {
    const dataToExport = this.datasource11.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Doc Type': row.doc_type,
      'File Number': row.doc_local_no,
      'Doc Desc': row.doc_desc,
      'Role': row.role_cd,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file_workflow');
  }

  export12() {
    const dataToExport = this.datasource12.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Doc Type': row.doc_type,
      'File Number': row.doc_local_no,
      'Doc Desc': row.doc_desc,
      'Role': row.role_cd,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file_workflow');
  }
  close() {
    $('#department').modal('hide');

  }
  // ////////last levl approval data from property /////////////////
  data_from_last_approval_prop: any = [];
  async last_appr_property() {
    this.spinner.show();
    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    let resp = await this.clerknocservice.last_level_approval_from_property(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.spinner.hide();
      this.data_from_last_approval_prop = resp['data'];
      console.log(this.data_from_last_approval_prop)
    } else {
      Swal.fire('info', 'server side error', 'error');
      this.spinner.hide();
      return
    }
  }

  check_houesetax(stepper: any) {
    if (this.house_flag) {
      if (!this.show_Data_obj['house_tax_paid']) {
        Swal.fire('info', 'Please select house tax paid', 'info');
        return
      }


      if (this.show_Data_obj['house_tax_paid'] == 'NO') {
        if (!this.show_Data_obj['house_tax']) {
          Swal.fire('info', 'Please Enter House Text', 'info');
          return
        }
      }
    }
    stepper.next();
  }
  // //////////////////////////////////insert into hoise Tax///////////////////////////////////
  async insert_housetax() {
    let data = new FormData()
    let doc_type = { 'supp_doc': [], 'doc_arr': [] }
    let doc_name = { 'supp_doc': [], 'doc_arr': [] }
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        data.append('file', this.selectedFile[i])
      }
      doc_type['supp_doc'].push('supportivedoc' as never)
      doc_name['supp_doc'].push(this.selected_file_name as never)
    }
    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id
    obj["description"] = this.show_Data_obj["description"]
    if (this.remark_note) {
      obj['description'] = this.remark_note
    }
    obj["lang"] = this.editorService.language
    obj['create_role'] = 'ZO'
    obj["file_id"] = this.show_Data_obj['file_details']['file_id']
    obj["user_id"] = this.ebillUser.user_id
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj['user_id'] = this.ebillUser.user_id
    obj['forwarded_by'] = this.ebillUser.user_id
    obj['forward_msg'] = this.appr_remark
    obj['remark'] = this.appr_remark
    obj['doc_type'] = 'TAX'
    obj['doc_local_no'] = this.show_Data_obj['file_details']['file_id']
    obj['doc_desc'] = `File Number ${this.show_Data_obj['file_details']['file_id']} Is Assigned to DEPARTMENT`
    obj['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
    obj['module_cd'] = 'NOC'
    obj['node_cd'] = this.alltabledata['node_cd'];
    obj['level'] = this.ApprovalUserService.level1['level']
    obj['undertaking'] = JSON.stringify([])
    obj['branch'] = this.ApprovalUserService.level1['branch']
    // obj['user_name'] = this.ebillUser.party_name;
    obj['field_value'] = 0
    obj['house_tax'] = this.show_Data_obj['house_tax'];
    obj['zo'] = true;
    let obj2: any = {};
    obj2['leaf_value'] = 'PUBLIC'
    obj2['leaf_cd'] = 1106
    obj2['doc_type'] = 'TAX'
    obj2['role_cd'] = 'ZO';
    obj['status'] = 'PENDING';
    obj['role_cd'] = 'PUBLIC'
    obj2['user_name'] = this.show_Data_obj['file_details']['party_name']
    obj['user_name'] = this.show_Data_obj['file_details']['party_name']
    let arr = [];
    arr.push(obj2)
    obj["department"] = arr
    data.append('data', JSON.stringify(obj))
    let resp = await this.clerknocservice.UPDATEnocfiledata(data)
    console.log(resp)
    if (resp["error"] == false) {
      let resp2 = await this.clerknocservice.insert_housetax(obj);
      if (resp2['error'] == false) {
        this.toastr.success("File Forwarded Successfully!!")
        this.show_ctp_flag = false;
        this.list_flag = true;
        await this.filedatasendbyctp();
      } else {
        Swal.fire('info', 'server side error', 'error');
        return
      }
    } else {
      Swal.fire('info', 'server side error', 'error');
      return
    }
  }
  // ////////////////////////////////insert cartographer /////////////////////////
  async cartographer_insert_data() {

    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id
    obj["description"] = this.show_Data_obj["description"]
    if (this.remark_note) {
      obj['description'] = this.remark_note
    }
    obj['create_role'] = 'CARTOGRAPHER'
    obj["user_id"] = this.ebillUser.user_id
    obj['user_id'] = this.ebillUser.user_id
    obj['doc_type'] = 'CARTOGRAPHER'
    let obj2: any = {};
    obj2['leaf_value'] = 'CARTOGRAPHER'
    obj2['leaf_cd'] = 1106
    obj2['doc_type'] = 'CARTOGRAPHER'
    obj2['role_cd'] = 'CARTOGRAPHER';
    obj['status'] = 'PENDING';
    obj['role_cd'] = 'CARTOGRAPHER'
    obj['file_id'] = this.salBill_apprdata['file_id']
    obj2['user_name'] = this.salBill_apprdata['party_name']
    obj['user_name'] = this.salBill_apprdata['party_name']
    let arr = [];
    arr.push(obj2)
    obj["department"] = arr

    let resp = await this.clerknocservice.cartographer_insert_data(obj)
    console.log(resp)
    if (resp["error"] == false) {
      //  this.toastr.success("File Forwarded Successfully!!")
    } else {
      Swal.fire('info', 'server side error', 'error');
      return
    }
  }
  // //////////////////////////////////////////////////Objection On file///////////////////////////////////////////////////////////////////













  objected_data: any = {}
  object_file(element: any) {
    this.objected_data = Object.assign({}, element)
    $('#objected').modal('show');
  }

  async rejectnewrowapproval() {
    this.remark_note = this.editorService.to_data
    let obj = Object.assign({}, this.objected_data)
    // let str = this.remark_note.trim()
    // if (str.length < 1) {
    if (this.remark_note == null) {
      Swal.fire('Info', "Please fill Mandatory Details", 'info');
      return
    }
    this.spinner.show()
    let obb = Object()
    obb['user_id'] = this.objected_data['user_id'];
    obb["user_name"] = this.objected_data['user_name'];
    obb['b_acct_id'] = this.ebillUser.b_acct_id;
    obb['forwarded_by'] = this.ebillUser.user_id;
    obb['forward_msg'] = this.editorService.to_data;
    obb['remark'] = ""
    obb['status'] = 'PENDING'
    obb['doc_type'] = this.objected_data['doc_type']//'EBILL'
    obb['doc_local_no'] = this.objected_data['doc_local_no']
    obb['doc_desc'] = this.objected_data['doc_desc']
    obb['role_cd'] = this.objected_data['role_cd']
    obb['module_cd'] = this.objected_data['module_cd'] //'EMB'
    obb['node_cd'] = this.objected_data['node_cd']
    obb['level'] = this.objected_data['level']
    obb['branch'] = this.objected_data['branch']
    obb['field_value'] = this.objected_data['field_value']
    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }

    const resp = await this.mainService.insertTask(obb)
    if (resp['error'] == false) {
      await this.rejectapproval(obj.id)
      await this.rejectdocment(obj)
      await this.getAllTaskOfUser()
      if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.ebillUser.le_id])
      this.spinner.hide();
      // $('#multiple_view').hide()
      // $('#remark_view').modal('hide');
      // this.multiple_view = false
      // this.remark_view = false
      // this.task_list = true
      // this.approval_flag = false
      // this.reject_flag = false
      this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
      Swal.fire("Success", `${this.ft_satatus} Successfully `, 'success');
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }

  }

  async rejectdoc() {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = this.rejectdata['doc_local_no']
    var resp = await this.portalmainservice.getembxrefappr(JSON.stringify(obj))
    if (resp['error'] == false) {
      await this.rejectdocstatus(JSON.parse(resp['data'][0]['data']))
    } else {
      Swal.fire("Error", resp['data'], 'error');
    }
  }
  async rejectdocstatus(idarr: any) {
    var obj: any = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['id'] = idarr
    obj['update_user_id'] = this.ebillUser.user_id
    obj['status'] = 'REJECTED'
    var resp = await this.portalmainservice.changestatus(obj)
    if (resp['error'] == false) {

    } else {
      Swal.fire("Error", resp['data'], 'error');
    }
  }
  async rejectdocment(element: any) {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['module_cd'] = element['module_cd']
    obb['status'] = 'REJECTED'
    obb['doc_type'] = element['doc_type']
    obb['doc_local_no'] = element['doc_local_no']
    obb['remark'] = this.appr_remark

    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }

  }

  async getle(user_id: any, p0: any) {
    let obj: any = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['le_id'] = user_id
    let resp = await this.mainService.getcurrentlegalentity(JSON.stringify(obj))
    if (resp['error'] == false) {
      await this.sendmessage(resp['data'][0]['phone_no'])
      this.spinner.hide();
      this.message_flag = false
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }
  }
  async sendmessage(mobile: any) {
    let resp = await this.portalmainservice.sendMsg(mobile, this.tender_apprdata['doc_type'] + ' Number ' + this.tender_apprdata['doc_local_no'])
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }



  // //////////////////////////////////////////////////////////////////Update File////////////////////////////////////////////////////////////////////////////////////
  update_objection: boolean = false
  async update(element: any) {
    this.NocObj = element
    this.NocObj['all_floor_area'] = element['floor_buld_area']
    this.NocObj['front_setback'] = element['front_stack']
    this.NocObj['left_set'] = element['side_stack_l']
    this.NocObj['right_set'] = element['side_stack_r']
    this.NocObj['back_setback'] = element['rare_stack']

    this.update_objection = true;
    this.list_flag = false


  }
  open_objection_list() {
    this.update_objection = false;
    this.list_flag = true;
    this.NocObj = {};
  }
  async submit_objection_file() {
    if (this.spanAvi == false) {
      Swal.fire('Info', "Please Enter Valid Email ID", 'info')
      return
    }
    if (!this.NocObj['all_floor_area']) {
      Swal.fire('info', 'Please Enter All Floors Building area', 'info');
      return
    }
    if (!this.NocObj['total_area']) {
      Swal.fire('info', 'Please Enter Total Area', 'info');
      return
    } if (!this.NocObj['front_setback']) {
      Swal.fire('info', 'Please Enter Front Setback', 'info');
      return
    } if (!this.NocObj['left_set']) {
      Swal.fire('info', 'Please Enter Side Setback Left', 'info');
      return
    } if (!this.NocObj['right_set']) {
      Swal.fire('info', 'Please Enter Side Setback Right', 'info');
      return
    } if (!this.NocObj['back_setback']) {
      Swal.fire('info', 'Please Enter Rare Set Back', 'info');
      return
    }



    if (this.NocObj['file_number'] == undefined || this.NocObj['file_number'] == null || this.NocObj['file_number'] == '' ||
      this.NocObj['lda_letter_number'] == undefined || this.NocObj['lda_letter_number'] == null || this.NocObj['lda_letter_number'] == '' ||
      this.NocObj['party_name'] == undefined || this.NocObj['party_name'] == null || this.NocObj['party_name'] == '' ||
      this.NocObj['party_mobile'] == undefined || this.NocObj['party_mobile'] == null || this.NocObj['party_mobile'] == '' ||

      this.NocObj['building_type'] == undefined || this.NocObj['building_type'] == null || this.NocObj['building_type'] == '' ||
      this.NocObj['subject'] == undefined || this.NocObj['subject'] == null || this.NocObj['subject'] == '' ||
      this.NocObj['party_email'] == undefined || this.NocObj['party_email'] == null || this.NocObj['party_email'] == '' ||
      this.NocObj['khasra_no'] == undefined || this.NocObj['khasra_no'] == null || this.NocObj['khasra_no'] == '' ||
      this.NocObj['plot_no'] == undefined || this.NocObj['plot_no'] == null || this.NocObj['plot_no'] == '' ||
      this.NocObj['address'] == undefined || this.NocObj['address'] == null || this.NocObj['address'] == ''
    ) {
      Swal.fire('info', 'All fields marked with * are Mandatory.', 'info')
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Add it!'
    }).then(async (result: any) => {
      if (result.value) {
        let ob: any = await this.rejectfilestatus(this.NocObj['file_id'], 'INACTIVE');
        if (ob['error'] == false) {
          await this.submitnocdata();
          this.open_objection_list();
        } else {
          Swal.fire('error', 'server side error', 'error');
        }
      }
    })
  }
  remark_text: any = {};
  async view_remark(ob: any) {
    console.log(ob);
    console.log(this.UserObj)
    this.remark_text = null;
    this.remark_text = JSON.parse(ob['remark']);
    this.remark_text['user_name'] = this.UserObj[ob['user_id']]
    console.log(this.remark_text);
    $('#remark').modal('show');
  }




}


